(function () {
    "use strict";

    /**
     * Defines a decorator to extend the shared HabilNavigator service.
     * This can be used to add the OpenIvm and OpenFvm methods which are defined in several 
     * controllers. It allows us to extract this logic on the app-level.
     */
    angular.module("app").config(extendServices);
    
    extendServices.$inject = ['$provide'];
    function extendServices($provide) {
        $provide.decorator('HabilNavigator', HabilNavigatorDecorator);
    }

    HabilNavigatorDecorator.$inject = ["$delegate", "enumService"];
    function HabilNavigatorDecorator($delegate, enumService) {
        const navigator = $delegate;
        
        navigator.Dossier = {
            Person: openDossierPerson,
            Organisation: openDossierOrganisation
        };

        navigator.OpenDossierPerson = openDossierPerson;
        navigator.OpenDossierOrganisation = openDossierOrganisation;

        navigator.OpenIvmScreening = openIvmScreening;
        navigator.OpenFvmScreening = openFvmScreening;

        navigator.ReviewIvm = openIvm;
        navigator.OpenIvm = openIvm;
        navigator.OpenIvmViewOnly = openIvmViewOnly;
        
        navigator.OpenFvmViewOnly = openFvmViewOnly;
       
        navigator.Cis = {
            OpenRequest: (id) => navigator.OpenByIdAndRoute(id, "Cis/Request/"),
            OpenScreening: (id) => navigator.OpenByIdAndRoute(id, "Cis/Screening/"),
        };

        navigator.Search = {
            OpenSearchUsersByKeywords: openSearchUsersByKeywords
        };

        return navigator;
        
        function openDossierOrganisation(id, openInNewTab = true) {
            navigator.OpenByIdAndRoute(id, `Dossier/Organisation/?dossierId=`, openInNewTab);
        }

        function openDossierPerson(id, openInNewTab = true) {
            navigator.OpenByIdAndRoute(id, `Dossier/Person/?`, openInNewTab);
        }

        function openIvmScreening(id) {
            navigator.OpenByIdAndRoute(id, `Screenings/IVMRequest/?requestId=`);
        }

        function openFvmScreening(id, canEdit) {
            const route = (canEdit) ? `Screenings/FVMRequest/?edit=1&screeningId=`: `Screenings/FVMRequest/?screeningId=`;
            navigator.OpenByIdAndRoute(id, route);
        }

        function openIvm(id, status) {
            switch (parseInt(status)) {
                case enumService.IvmStatusCodes.ScreeningOngoing:
                case enumService.IvmStatusCodes.AssistanceINStarted:
                    openIvmScreening(id);
                    break;
                default:
                    openIvmViewOnly(id);
                    break;
            }
        }

        function openIvmViewOnly(id, openInNewTab = false) {
            navigator.OpenByIdAndRoute(id, "Person/Request/ViewOnly/?", openInNewTab);
        }

        function openFvmViewOnly(id) {
            navigator.OpenByIdAndRoute(id, "Organisation/Request/ViewOnly/?requestId=");
        }

        function openSearchUsersByKeywords(keywords, openSelf = false) {
            keywords = Array.isArray(keywords) ? keywords.join(" ") : keywords;

            const routeBuilder = navigator.GetRouteBuilder("Administration/UsersByRole?").AddParameter("Keywords", keywords);

            const route = routeBuilder.GetRoute();

            openSelf ? navigator.OpenRoute(route) : navigator.OpenRouteInTab(route);
        }
    }
})();
